export default function Legend({ color, label }) {
  return (
    <div className="flex items-center gap-2">
      <span
        className={`w-3.5 h-3 rounded flexshrink-0
          ${color === "blue" && "bg-[#357BE0]"}
          ${color === "green" && "bg-[#1FAD77]"}
          ${color === "orange" && "bg-[#B9782E]"}
        `}
      />
      <span>{label}</span>
    </div>
  );
}